export default defineNuxtPlugin((nuxtApp) => {
  // nuxtApp.hook("page:finish", () => {
  //   const loadingElement = document.querySelector(".full-screen-loader");
  //   if (loadingElement) {
  //     loadingElement.style = "display: none;";
  //     sessionStorage.setItem("loading", "true");
  //   }
  // });
});
